import PropTypes from "prop-types";

export default function InstitutionalHero({ image, title, subtitle, home = false }) {
  return (
    <header className={`school-hero${home ? " school-hero--home" : ""}`}>
      <img className="school-hero__image" src={image} alt="" fetchPriority="high" />
      <div className="school-hero__content">
        {title && <h1>{title}</h1>}
        {subtitle && <p>{subtitle}</p>}
      </div>
    </header>
  );
}

InstitutionalHero.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  home: PropTypes.bool,
};
